class ProductForm extends HTMLElement {
  constructor() {
    super()
    this.SECTION_ID = this.dataset.sectionId || "product-template"
    this.cache = {}
    this.SCOPE = "pdp"
  }
  connectedCallback() {
    // add this because of a Chromium bug
    let intervId
    const check = () => {
      if (
        this.childElementCount > 0 &&
        this.querySelector(`[data-scope="${this.SCOPE}"] [data-add-to-cart]`)
      ) {
        clearInterval(intervId)
        intervId = null
        this.init()
      }
    }
    intervId = setInterval(check, 200)
  }
  init() {
    this.currentHandle = this.querySelector(
      `[data-scope="${this.SCOPE}"] [data-swatch][data-selected]`
    ).dataset.productHandle
    const startingHTML = new DOMParser().parseFromString(this.innerHTML, "text/html")
    this.cache[this.currentHandle] = startingHTML
    this.setUpElements()
    this.setUpSwatches()
    // Set variant data and default variant id if there is only 1
    if (this.variantData.length === 1) {
      this.currentVariant = this.variantData[0]
    }
    // Listen for variant change
    this.addEventListener("change", this.onVariantChange)
    this.wishlistSetup()
    this.customCTA = this.querySelector(`[data-custom-cta][data-scope="${this.SCOPE}"]`)
      ? true
      : false
    this.setAttribute("data-custom-cta", this.customCTA)
    this.updateSeoMetaTag()
  }
  updateSeoMetaTag() {
    if (this.SCOPE !== "pdp") {
      return
    }
    const $title = document.querySelector("title")
    const currentVariantName = this.querySelector("h1").innerText

    $title.innerText = currentVariantName.replace("  ", " ").trim()
  }
  setUpElements() {
    this.form = this.querySelector(`[data-main-form][data-scope="${this.SCOPE}"]`)
    this.CTA = this.querySelector(`[data-scope="${this.SCOPE}"] [data-add-to-cart]`)
    this.CTA.addEventListener("click", () => {
      this.addToCart()
    })
    this.backInStock = this.querySelector(`[data-scope="${this.SCOPE}"] [data-back-in-stock]`)
    this.variantData = JSON.parse(
      this.querySelector(`[type="application/json"][data-scope="${this.SCOPE}"][data-variant-data]`)
        .textContent
    )
    this.productId = JSON.parse(
      this.querySelector(`[type="application/json"][data-scope="${this.SCOPE}"][data-product-data]`)
        .textContent
    )
    this.setUpZoom()
  }
  setUpSwatches() {
    this.swatches = this.querySelectorAll(
      `[data-fieldset][data-scope="${this.SCOPE}"] [data-swatch]`
    )
    this.watchSwatches()
  }
  onVariantChange(e) {
    let scope = e.target.closest("[data-scope]").getAttribute("data-scope")
    if (scope !== this.SCOPE) {
      return
    }
    this.updateOptions()
    this.updateMasterId()
    this.updateCTAtext()
    this.updateVariantStatuses()
    this.updateStock()
    this.renderNewVariant(e.target)
    if (this.dataset.updateUrl === "true" || this.dataset.updateUrl === true) {
      this.updateVariantURL()
    }
  }
  updateVariantURL() {
    if (!this.currentVariant || this.currentVariant == 0) {
      return
    }
    let url = new URL(window.location.href)
    let params = new URLSearchParams(url.search)
    params.set("variant", this.currentVariant.id)
    params.toString()
    window.history.replaceState(
      {},
      "",
      `${window.location.origin}${window.location.pathname}?${params.toString()}`
    )
  }
  onProductChange(handle) {
    if (this.dataset.updateUrl === "true" || this.dataset.updateUrl === true) {
      window.history.replaceState({}, "", `/products/${handle}`)
      this.updateSeoMetaTag()
    }
    this.updateOptions()
    this.updateMasterId()
    // let the rest of the page know that the product has changed
    const productChange = new CustomEvent("product-change", {
      detail: {
        product: handle
      },
      bubbles: true
    })
    this.dispatchEvent(productChange)
    this.updateStock()
    window?.Cloudlift?.upload.App.setup()
    this.wishlistSetup()
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(`[data-scope="${this.SCOPE}"][data-fieldset] input:checked`),
      (option) => option.value
    )
  }
  updateMasterId() {
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }
  updateCTAtext() {
    if (this.currentVariant) {
      if (this.currentVariant.available) {
        this.CTA.innerText = this.CTA.dataset.defaultAddText
          ? this.CTA.dataset.defaultAddText
          : "Add to Bag"
      } else {
        this.CTA.innerText = this.CTA.dataset.defaultSoldOutText
          ? this.CTA.dataset.defaultSoldOutText
          : "Sold Out - Notify Me When Available"
      }
    }
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.form.querySelector(":checked")?.value === variant.option1
    )
    const inputWrappers = [...this.form.querySelectorAll(`[data-fieldset]`)]
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOption = inputWrappers[index - 1].querySelector(":checked")
      if (!previousOption) {
        this.CTA.innerText = "Select " + inputWrappers[index - 1].querySelector("legend").innerText
        return
      }
      const previousOptionSelected = previousOption.value
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`])
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }
  updateStock() {
    if (!this.currentVariant || this.currentVariant == 0) {
      this.setAttribute("data-in-stock", "")
      return
    }
    this.setAttribute("data-in-stock", this.currentVariant.available)
    this.backInStock.querySelector("form").addEventListener("submit", (e) => {
      e.preventDefault()
      this.addBackInStock()
    })
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.removeAttribute("data-sold-out")
      } else {
        input.setAttribute("data-sold-out", true)
      }
    })
  }
  renderNewProduct(handle) {
    this.setAttribute("data-loading", true)
    this.currentHandle = handle

    const swapHTML = (newHTML) => {
      this.querySelectorAll(`[data-swap][data-scope="${this.SCOPE}"]`).forEach((swap) => {
        swap.innerHTML = newHTML.querySelector(
          `[data-swap="${swap.dataset.swap}"][data-scope="${this.SCOPE}"]`
        ).innerHTML
      })
      if (newHTML.querySelector(`[data-custom-cta][data-scope="${this.SCOPE}"]`)) {
        this.customCTA = true
      } else {
        this.customCTA = false
      }
      this.setAttribute("data-custom-cta", this.customCTA)
      this.setAttribute("data-loading", false)
    }

    if (this.cache.hasOwnProperty(handle)) {
      swapHTML(this.cache[handle])
      this.setUpElements()
      this.onProductChange(handle)
      return
    }

    fetch(`/products/${handle}?section_id=${this.SECTION_ID}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html")
        swapHTML(html)
        this.cache[handle] = html
      })
      .then(() => {
        this.setUpElements()
        this.onProductChange(handle)
      })
  }
  renderNewVariant(target) {
    if (!this.currentVariant || this.currentVariant == 0) {
      return
    }

    let regularPriceTarget = this.currentVariant.price,
      compareAtPriceTarget = null,
      currencyTarget = null
    if (target) {
      regularPriceTarget = target.dataset.variantPrice || ""
      compareAtPriceTarget = target.dataset.variantComparePrice || ""
      currencyTarget = target.dataset.variantCurrency || ""
    }
    let salePrice = this.querySelector(".pdp__price .js-product-price-on-sale-value"),
      compareAtPrice = this.querySelector(".pdp__price .js-product-price-compare-at-value"),
      regularPrice = this.querySelector(".pdp__price .js-pdp__price-value")
    const updatePriceDisplay = (priceTarget, priceElement, parentElement, isSale = false) => {
      if (priceElement) {
        priceElement.textContent = priceTarget ? `${priceTarget} ${currencyTarget}` : ""
        parentElement.style.marginRight = priceTarget ? "5px" : "0px"
      }
    }
    if (compareAtPriceTarget) {
      updatePriceDisplay(regularPriceTarget, salePrice, salePrice?.parentElement, true)
      updatePriceDisplay(compareAtPriceTarget, compareAtPrice, compareAtPrice?.parentElement)
      if (regularPrice) regularPrice.textContent = ""
    } else {
      updatePriceDisplay(regularPriceTarget, regularPrice, regularPrice?.parentElement)
      updatePriceDisplay(null, salePrice, salePrice?.parentElement)
      updatePriceDisplay(null, compareAtPrice, compareAtPrice?.parentElement)
    }
    const wishlistElement = this.querySelector(
      `[scope="${this.SCOPE}"][co-wishlist] [data-variant]`
    )
    if (wishlistElement) {
      wishlistElement.dataset.variant = this.currentVariant.id
    }
    const inventoryElement = this.querySelector("[data-product-inventory]")
    if (inventoryElement) {
      inventoryElement.dataset.show =
        this.currentVariant.inventory_quantity > 0 && this.currentVariant.inventory_quantity < 4
      const inventorySpan = inventoryElement.querySelector("span")
      if (inventorySpan) {
        inventorySpan.innerText = this.currentVariant.inventory_quantity
      }
    }
    this.wishlistSetup()
  }
  watchSwatches() {
    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        this.querySelectorAll("[data-selected]").forEach((selected) => {
          selected.removeAttribute("data-selected")
          selected.setAttribute("aria-checked", "false")
          selected.setAttribute("tabindex", "-1")
        })
        swatch.setAttribute("data-selected", "true")
        this.renderNewProduct(swatch.dataset.productHandle)
        if (swatch.getAttribute("data-selected") === "true") {
          swatch.setAttribute("aria-checked", "true")
          swatch.setAttribute("tabindex", "0")
        } else {
          swatch.setAttribute("aria-checked", "false")
          swatch.setAttribute("tabindex", "-1")
        }
      })
      swatch.addEventListener("mouseenter", () => {
        const target = this.querySelector("[data-tooltip-target]")
        const content = swatch.querySelector("[data-tooltip-content]")
        if (!target) {
          return
        }
        if (!content) {
          return
        }
        target.innerHTML = content.innerHTML
        target.querySelector("[data-tooltip]").style.left = `${
          swatch.offsetLeft - swatch.parentElement.scrollLeft
        }px`
      })
      swatch.addEventListener("mouseleave", () => {
        const target = this.querySelector("[data-tooltip-target]")
        if (!target) {
          return
        }
        target.innerHTML = ""
      })
    })
  }
  addToCart() {
    if (!this.currentVariant || this.currentVariant == 0) {
      return
    }
    // check for pet inputs
    const petName = this.querySelector("#pet-name-input")
    if (petName && petName.value.length === 0) {
      petName.closest("[data-error]").setAttribute("data-error", true)
      return
    } else if (petName) {
      petName.closest("[data-error]").setAttribute("data-error", false)
    }
    const petImage = this.querySelector("#pet-image-upload")
    const petImageInput = this.querySelector('#pet-image-upload [name="properties[Pet Image]"]')
    if (petImage && !petImageInput?.value.length) {
      petImage.closest("[data-error]").setAttribute("data-error", true)
      return
    } else if (petImage) {
      petImage.closest("[data-error]").setAttribute("data-error", false)
    }

    if (!this.currentVariant.available) {
      this.backInStock.querySelector("[data-back-in-stock-button]").click()
      return
    }
    let line_item_properties = {}
    if (this.querySelector(`[data-scope="${this.SCOPE}"][data-pre-order]`)) {
      line_item_properties["NOTE"] = this.querySelector(
        `[data-scope="${this.SCOPE}"][data-pre-order]`
      ).innerText
    }
    const formData = new FormData(this.form)
    for (const pair of formData.entries()) {
      if (pair[0].includes("properties") && pair[1].length) {
        let name = pair[0].split("properties[")[1].replace("]", "")
        line_item_properties[name] = pair[1]
      }
    }
    CartJS.addItem(this.currentVariant.id, 1, line_item_properties, {
      success: function (data, textStatus, jqXHR) {
        if (document.querySelector("dialog[open]")) {
          document.querySelector("dialog[open]").close()
        }

        if (petImage && petImageInput?.value.length) {
          const $filepondRemoveItem = petImage.querySelector(".filepond--action-remove-item")
          const $filepondRevertItemProcessing = petImage.querySelector(
            ".filepond--action-revert-item-processing"
          )

          if (!$filepondRevertItemProcessing) return
          $filepondRevertItemProcessing.click()

          if (!$filepondRemoveItem) return
          $filepondRemoveItem.click()
        }

        window.setTimeout(function () {
          $("body").addClass("mini-cart-open")
          $("#mini-cart-title-id").focus()
        }, 100)
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(errorThrown)
      }
    })
  }
  addBackInStock() {
    if (!this.currentVariant || this.currentVariant == 0) {
      return
    }
    if (typeof BIS === "undefined") {
      return
    }
    if (this.backInStock.querySelector("[data-back-in-stock-input]").value.length === 0) {
      return
    }

    BIS.create(
      this.backInStock.querySelector("[data-back-in-stock-input]").value,
      this.currentVariant.id,
      this.productId
    ).then((resp) => {
      if (resp.status == "OK") {
        this.CTA.innerText = "Thank You!"
      } else {
        if (typeof resp !== "object") {
          this.CTA.innerText = "Oops"
          return
        }
        this.CTA.innerText = resp.errors?.base[0]
      }
    })
  }
  wishlistSetup() {
    const trigger = this.querySelector(`[data-scope="${this.SCOPE}"][co-wishlist] [data-variant]`)
    if (!trigger) {
      return
    }
    trigger.classList.remove("iwishAdded")
    trigger.innerText = "Add to Wishlist"
    trigger.addEventListener("click", (e) => {
      e.preventDefault()
      window.iwish_addCollection(jQuery(e.target), e.target.dataset.variant)
    })
  }
  setUpZoom() {
    const triggers = this.querySelectorAll("[data-product-zoom-trigger]")
    const dialog = this.querySelector("[data-product-zoom-dialog]")

    const trapFocus = (event) => {
      const focusableElements = dialog.querySelectorAll(
        'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      if (event.key === "Tab") {
        if (event.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          }
        } else {
          // Tab
          if (document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      } else if (event.key === "Escape") {
        dialog.close()
        triggers[0].focus() // Move focus back to the trigger after closing
        document.removeEventListener("keydown", trapFocus)
      }
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        if (window.innerWidth < 768) {
          return
        }
        const zoomImage = document.createElement("img")
        zoomImage.src = trigger.dataset.imageTarget

        // Get aria-label from the parent div and set it as alt text
        const ariaLabel = dialog.getAttribute("aria-label")
        if (ariaLabel) {
          zoomImage.setAttribute("alt", ariaLabel)
        }

        zoomImage.setAttribute("tabindex", "0") // Make the image focusable

        const contentInner = dialog.querySelector("[data-content-inner]")
        contentInner.innerHTML = ""
        contentInner.appendChild(zoomImage)

        dialog.showModal()

        // Trap focus within the dialog
        document.addEventListener("keydown", trapFocus)
        const firstFocusable = dialog.querySelector(
          'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
        )
        if (firstFocusable) {
          firstFocusable.focus()
        }
      })
    })
  }
}

customElements.define("product-form", ProductForm)

window.addEventListener("load", function () {
  var colorGroups = document.querySelectorAll(".pdp__fieldset--swatches")
  const moreDetailWrapper = document.querySelector(".pdp-more-detail-wrapper")

  colorGroups.forEach(function (group) {
    var colorButtons = group.querySelectorAll(".pdp__swatch")

    colorButtons.forEach(function (colorButton) {
      colorButton.addEventListener("click", function (e) {
        selectColorButton(colorButton)
      })

      colorButton.addEventListener("keydown", function (e) {
        switch (e.key) {
          case "ArrowUp":
          case "ArrowLeft":
            e.preventDefault()
            selectPreviousColorButton(colorButton)
            break

          case "ArrowDown":
          case "ArrowRight":
            e.preventDefault()
            selectNextColorButton(colorButton)
            break

          case " ":
          case "Enter":
            e.preventDefault()
            selectColorButton(colorButton)
            break
        }
      })
    })
  })

  function selectPreviousColorButton(colorButton) {
    var buttons = Array.prototype.slice.call(
      colorButton.closest(".pdp__swatches").querySelectorAll(".pdp__swatch")
    )
    var index = buttons.indexOf(colorButton)

    if (index > 0) {
      selectColorButton(buttons[index - 1])
    } else {
      selectColorButton(buttons[buttons.length - 1])
    }
  }

  function selectNextColorButton(colorButton) {
    var buttons = Array.prototype.slice.call(
      colorButton.closest(".pdp__swatches").querySelectorAll(".pdp__swatch")
    )
    var index = buttons.indexOf(colorButton)

    if (index < buttons.length - 1) {
      selectColorButton(buttons[index + 1])
    } else {
      selectColorButton(buttons[0])
    }
  }

  function selectColorButton(colorButton) {
    var buttons = colorButton.closest(".pdp__swatches").querySelectorAll(".pdp__swatch")
    buttons.forEach(function (button) {
      button.setAttribute("tabindex", -1)
      button.setAttribute("aria-checked", "false")
      button.classList.remove("selected")
    })

    colorButton.setAttribute("tabindex", 0)
    colorButton.setAttribute("aria-checked", "true")
    colorButton.classList.add("selected")
    colorButton.focus()

    // Trigger the click event programmatically
    colorButton.click()
  }
  function initializeAccordion(moreDetailWrapper) {
    moreDetailWrapper.querySelectorAll(".pdp__details-button").forEach((button) => {
      button.addEventListener("click", () => {
        const isExpanded = button.getAttribute("aria-expanded") === "true"
        const detailsItem = button.closest(".pdp__details-item")

        // Toggle the active class for the clicked item
        detailsItem.classList.toggle("active", !isExpanded)
        button.setAttribute("aria-expanded", !isExpanded)
      })
    })
  }

  if (moreDetailWrapper) {
    initializeAccordion(moreDetailWrapper)
  }
})

function handleShowMoreClick(button) {
  const filterDetails = button.closest(".ff__filter_details");
  if (filterDetails) {
      const checkboxes = filterDetails.querySelectorAll("ul.ff__filter_values .ff__filter_checkbox");
      if (checkboxes.length >= 12) {
          const twelfthCheckbox = checkboxes[11]; 
          twelfthCheckbox.focus(); // Move focus to the 12th checkbox
      }
  }
}


class StickyAddToCart extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    // add this because of a Chromium bug
    let intervId
    const check = () => {
      if (this.childElementCount > 0) {
        clearInterval(intervId)
        intervId = null
        this.init()
      }
    }
    intervId = setInterval(check, 200)
  }
  init() {
    this.setUpElements()
    this.setUpObservers()
    this.connectObservers()
    this.pdp.addEventListener("product-change", () => {
      this.disconnectObservers()
      this.fakePDPContainer.classList.remove("visible")
      setTimeout(() => {
        this.setUpElements()
        this.setUpObservers()
        this.connectObservers()
      }, 300)
    })
  }
  setUpElements() {
    this.pdp = this.closest("product-form")
    this.realPDPbutton = this.pdp.querySelector("[data-add-to-cart]")
    this.fakePDPContainer = this.querySelector(".sticky-cta")
    this.fakePDPbutton = this.querySelector(".sticky-cta button")
    this.cltContainer = document.querySelector("complete-the-look-list")
  }
  setUpObservers() {
    if (window.innerWidth > 767) {
      return
    }
    if (!this.pdp) {
      return
    }

    this.fakePDPbutton.innerText = this.realPDPbutton.innerText
    this.stickyPDPoptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5
    }
    this.stickyPDPcallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.fakePDPContainer.classList.remove("visible")
        } else {
          if (this.cltContainer.innerHTML) {
            return
          }
          this.fakePDPContainer.classList.add("visible")
        }
      })
    }
    this.stickyPDPobserver = new IntersectionObserver(this.stickyPDPcallback, this.stickyPDPoptions)

    this.fakePDPbutton.addEventListener("click", (e) => {
      e.preventDefault()
      this.realPDPbutton.click()
      if (!this.pdp.currentVariant || !this.pdp.currentVariant.available) {
        this.realPDPbutton.scrollIntoView({ behavior: "smooth", block: "center" })
      }
    })

    // Callback function to execute when mutations are observed
    this.pdpMutationCallback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          if (this.realPDPbutton.innerHTML !== this.fakePDPbutton.innerHTML) {
            this.fakePDPbutton.innerHTML = this.realPDPbutton.innerHTML
          }
        } else if (mutation.type === "attributes") {
        }
      }
    }
    // Create an observer instance linked to the callback function
    this.pdpMutationObserver = new MutationObserver(this.pdpMutationCallback)
  }
  connectObservers() {
    if (!this.stickyPDPobserver) return
    this.stickyPDPobserver.observe(this.realPDPbutton)
    this.pdpMutationObserver.observe(this.realPDPbutton, {
      attributes: true,
      childList: true,
      subtree: true
    })
  }
  disconnectObservers() {
    if (!this.stickyPDPobserver) return
    this.stickyPDPobserver.unobserve(this.realPDPbutton)
    // this.pdpMutationObserver.unobserve(this.realPDPbutton)
  }
}

customElements.define("sticky-add-to-cart", StickyAddToCart)

class ProductImages extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    // add this because of a Chromium bug
    let intervId
    const check = () => {
      if (this.childElementCount > 0 && this.querySelectorAll("[co-slider] [data-slide]").length) {
        clearInterval(intervId)
        intervId = null
        this.init()
      }
    }
    intervId = setInterval(check, 200)
  }
  init() {
    this.slides = this.querySelectorAll("[co-slider] [data-slide]")
    this.slideCount = this.slides.length
    this.thumbs = this.querySelectorAll("[co-thumbs] button")
    this.numberOfPetOptions = document.querySelectorAll(".js-number-of-pets")

    if (this.thumbs.length) {
      this.setupThumbs()
    }

    if (this.numberOfPetOptions) {
      this.addNumberOfPetsClickEventListeners()
    }

    this.handleClick()
    this.handleSwipe()

    // Set the initial slide
    const initialSlide = this.dataset.activeSlide || 1
    this.setSlide(initialSlide)
  }
  addNumberOfPetsClickEventListeners() {
    this.numberOfPetOptions.forEach((element) =>
      element.addEventListener("click", () => {
        this.setSlide(Number(element.attributes.index.value))
      })
    )
  }
  setupThumbs() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        this.dataset.activeSlide = thumb.dataset.setActiveSlide
      })
    })
  }
  static get observedAttributes() {
    return ["data-active-slide"]
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!this.slides) {
      return
    }
    this.setSlide(newValue)
  }
  handleClick() {
    this.prev = this.querySelector('[data-action="prev"]')
    this.next = this.querySelector('[data-action="next"]')
    this.prev.addEventListener("click", () => {
      this.slideMinus()
    })
    this.next.addEventListener("click", () => {
      this.slidePlus()
    })
  }
  handleSwipe() {
    let touchstartX = 0
    let touchendX = 0
    const checkDirection = () => {
      if (touchendX < touchstartX) this.slidePlus()
      if (touchendX > touchstartX) this.slideMinus()
    }
    this.addEventListener("touchstart", (e) => {
      touchstartX = e.changedTouches[0].screenX
    })
    this.addEventListener("touchend", (e) => {
      touchendX = e.changedTouches[0].screenX
      checkDirection()
    })
  }
  slidePlus() {
    let activeSlide = Number(this.dataset.activeSlide)
    if (activeSlide === this.slideCount) {
      this.dataset.activeSlide = 1
    } else {
      this.dataset.activeSlide = activeSlide + 1
    }
  }
  slideMinus() {
    let activeSlide = Number(this.dataset.activeSlide)
    if (activeSlide === 1) {
      this.dataset.activeSlide = this.slideCount
    } else {
      this.dataset.activeSlide = activeSlide - 1
    }
  }
  setSlide(slideNumber) {
    if (!this.slides.length) {
      return
    }
    this.slides.forEach((slide, index) => {
      const slideWrap = slide.closest(".slide-wrap")
      if (slideWrap) {
        slideWrap.setAttribute("aria-hidden", "true")
        slideWrap.setAttribute("tabindex", "-1")
        slideWrap.setAttribute("aria-label", `slide ${index + 1} of ${this.slideCount}`)
      }
      slide.setAttribute("data-active", false)
    })
    const activeSlide = this.querySelector(`[co-slider] [data-slide="${slideNumber}"]`)
    const activeSlideWrap = activeSlide.closest(".slide-wrap")
    this.slides.forEach((slide, index) => {
      // Find the closest parent with either .slide-wrap or .pdp_main_image_slide
      const activeSlideWrap = slide.closest(".slide-wrap") || slide.closest(".pdp_main_image_slide")
  
      if (activeSlideWrap) {
        // Check if the slide is the active one
        if (slide.getAttribute("data-slide") === String(slideNumber)) {
          // Active slide
          activeSlideWrap.removeAttribute("aria-hidden")
          activeSlideWrap.removeAttribute("tabindex")
          activeSlideWrap.focus() // Focus the active slide
          activeSlideWrap.classList.add("active")
        } else {
          // Inactive slide
          activeSlideWrap.setAttribute("aria-hidden", "true")
          activeSlideWrap.setAttribute("tabindex", "-1")
          activeSlideWrap.classList.remove("active")
        }
  
        // If the slide has an image inside a button (.pdp_main_image_slide), check its data-active attribute
        const imageButton = activeSlideWrap.querySelector(".pdp_main_image_slide img")
        if (imageButton) {
          if (imageButton.closest('button').getAttribute('data-active') === "false") {
            imageButton.setAttribute("aria-hidden", "true")
            imageButton.setAttribute("tabindex", "-1")
          } else {
            imageButton.removeAttribute("aria-hidden")
            imageButton.removeAttribute("tabindex")
          }
        }
  
        activeSlideWrap.setAttribute("aria-label", `slide ${index + 1} of ${this.slideCount}`)
      }
      slide.setAttribute("data-active", slide.getAttribute("data-slide") === String(slideNumber))
    })
  
    // Update the thumbs for active/inactive states
    this.thumbs.forEach((thumb) => {
      thumb.setAttribute("data-active", false)
      thumb.setAttribute("aria-current", false)
    })

    activeSlide.setAttribute("data-active", true)
    if (!this.thumbs.length) {
      return
    }
    this.thumbs.forEach((thumb) => {
      thumb.setAttribute("data-active", false)
      thumb.setAttribute("aria-current", false)
    })
    this.querySelector(`[co-thumbs] [data-set-active-slide="${slideNumber}"]`).setAttribute(
      "data-active",
      true
    )
    this.querySelector(`[co-thumbs] [data-set-active-slide="${slideNumber}"]`).setAttribute(
      "aria-current",
      "true"
    )
    let scroll =
      this.querySelector(`[co-thumbs] [data-set-active-slide="${slideNumber}"]`).offsetTop -
      this.querySelector(`[co-thumbs] [data-set-active-slide="${slideNumber}"]`).clientHeight
    this.querySelector("[co-thumbs]").scrollTo(0, scroll)
  }
}

customElements.define("product-images", ProductImages)

class OverflowList extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    // add this because of a Chromium bug
    setTimeout(() => {
      this.observeSelf()
    }, 100)
  }
  init() {
    this.style.maxWidth = "100%"
    this.scrollContainer = this.querySelector("[data-overflow-list]")
    if (!this.scrollContainer) {
      return
    }
    this.setAttribute("data-initialized", true)
    this.childElements = this.querySelectorAll("[data-overflow-item]")
    this.arrowRight = this.querySelector('[data-overflow-arrow="right"]')
    this.arrowLeft = this.querySelector('[data-overflow-arrow="left"]')
    if (this.scrollContainer.scrollWidth <= this.scrollContainer.clientWidth) {
      return
    }

    this.LABEL_SIZE =
      Number(
        getComputedStyle(this.scrollContainer).getPropertyValue("--label-size").split("px")[0]
      ) || 36
    this.GAP =
      Number(getComputedStyle(this.scrollContainer).getPropertyValue("--gap").split("px")[0]) || 6

    this.overflow()
  }
  overflow() {
    let swatchesToShow = this.scrollContainer.clientWidth / (this.LABEL_SIZE + this.GAP)
    swatchesToShow = Math.floor(swatchesToShow)
    // minus one for the arrow
    // swatchesToShow = swatchesToShow - 1
    let newWidth = `${swatchesToShow * this.LABEL_SIZE + (swatchesToShow - 1) * this.GAP}px`
    this.style.maxWidth = newWidth

    this.arrowRight.style.display = "block"
    this.arrowRight.addEventListener("click", () => {
      this.scrollContainer.scrollBy(this.LABEL_SIZE, 0)
    })

    this.arrowLeft.style.display = "none"
    this.arrowLeft.addEventListener("click", () => {
      this.scrollContainer.scrollBy(-this.LABEL_SIZE, 0)
    })

    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.99
    }
    let callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.target == this.childElements[0] && entry.intersectionRatio > 0) {
          this.arrowLeft.style.display = "none"
        } else if (this.scrollContainer.scrollLeft < entry.target.clientWidth) {
          this.arrowLeft.style.display = "none"
        } else {
          this.arrowLeft.style.display = "block"
        }
        if (
          entry.target == this.childElements[this.childElements.length - 1] &&
          entry.intersectionRatio > 0
        ) {
          this.arrowRight.style.display = "none"
        } else if (
          this.scrollContainer.scrollLeft + this.scrollContainer.clientWidth >=
          this.scrollContainer.scrollWidth
        ) {
          this.arrowRight.style.display = "none"
        } else {
          this.arrowRight.style.display = "block"
        }
      })
    }
    let observer = new IntersectionObserver(callback, options)
    this.childElements.forEach((child) => {
      observer.observe(child)
    })
  }
  observeSelf() {
    if (this.getAttribute("data-observed")) {
      return
    }
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0
    }
    let callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.setAttribute("data-observed", true)
          this.init()
        }
      })
    }
    let observer = new IntersectionObserver(callback, options)
    observer.observe(this)
  }
}

customElements.define("overflow-list", OverflowList)

class CompleteTheLook extends ProductForm {
  constructor() {
    super()
    this.SECTION_ID = "complete-the-look"
    this.DIALOG_SECTION = "product-quickshop"
    this.SCOPE = "clt"
  }

  renderNewVariant() {
    return
  }

  setUpElements() {
    super.setUpElements()
    this.quickshopSetup()
    this.initializeColorSwatches(this)
    this.initializeAccordion(this)
  }

  quickshopSetup() {
    const triggers = this.querySelectorAll(`[data-quick-shop-trigger="${this.SCOPE}"]`)
    const dialog = this.querySelector(`dialog[data-scope="${this.SCOPE}"]`)
    if (!triggers.length || !dialog) {
      return
    }
    if (this.closest("dialog")) {
      return
    }
    triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault()
        dialog.querySelector("[data-content]").setAttribute("data-loading", true)
        !dialog.open && dialog.showModal()
        fetch(`${trigger.getAttribute("href")}?section_id=${this.DIALOG_SECTION}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html")
            dialog.querySelector("[data-content-inner]").innerHTML =
              html.querySelector("product-form").outerHTML
            dialog.querySelector("[data-content]").setAttribute("data-loading", false)

            // Initialize the color swatches in the dialog
            this.initializeColorSwatches(dialog)
            this.initializeAccordion(dialog)
          })
      })
    })
    dialog.addEventListener("click", (e) => {
      if (!e.target.closest("[data-content]")) {
        dialog.close()
      }
    })
  }
  initializeAccordion(dialog) {
    dialog.querySelectorAll(".pdp__details-button").forEach((button) => {
      button.addEventListener("click", () => {
        const isExpanded = button.getAttribute("aria-expanded") === "true"
        const detailsItem = button.closest(".pdp__details-item")

        // Toggle the active class for the clicked item
        detailsItem.classList.toggle("active", !isExpanded)
        button.setAttribute("aria-expanded", !isExpanded)
      })
    })
  }
  initializeColorSwatches(context) {
    const colorGroups = context.querySelectorAll(".pdp__fieldset--swatches")

    colorGroups.forEach(function (group) {
      const colorButtons = group.querySelectorAll(".pdp__swatch")

      colorButtons.forEach(function (colorButton) {
        colorButton.addEventListener("click", function (e) {
          selectColorButton(colorButton)
        })

        colorButton.addEventListener("keydown", function (e) {
          switch (e.key) {
            case "ArrowUp":
            case "ArrowLeft":
              e.preventDefault()
              selectPreviousColorButton(colorButton)
              break

            case "ArrowDown":
            case "ArrowRight":
              e.preventDefault()
              selectNextColorButton(colorButton)
              break

            case " ":
            case "Enter":
              e.preventDefault()
              selectColorButton(colorButton)
              break
          }
        })
      })
    })

    function selectPreviousColorButton(colorButton) {
      const buttons = Array.prototype.slice.call(
        colorButton.closest(".pdp__swatches").querySelectorAll(".pdp__swatch")
      )
      const index = buttons.indexOf(colorButton)

      if (index > 0) {
        selectColorButton(buttons[index - 1])
      } else {
        selectColorButton(buttons[buttons.length - 1])
      }
    }

    function selectNextColorButton(colorButton) {
      const buttons = Array.prototype.slice.call(
        colorButton.closest(".pdp__swatches").querySelectorAll(".pdp__swatch")
      )
      const index = buttons.indexOf(colorButton)

      if (index < buttons.length - 1) {
        selectColorButton(buttons[index + 1])
      } else {
        selectColorButton(buttons[0])
      }
    }

    function selectColorButton(colorButton) {
      const buttons = colorButton.closest(".pdp__swatches").querySelectorAll(".pdp__swatch")
      buttons.forEach(function (button) {
        button.setAttribute("tabindex", -1)
        button.setAttribute("aria-checked", "false")
        button.classList.remove("selected")
      })

      colorButton.setAttribute("tabindex", 0)
      colorButton.setAttribute("aria-checked", "true")
      colorButton.classList.add("selected")
      colorButton.focus()

      // Trigger the click event programmatically
      colorButton.click()
    }
  }
}

customElements.define("complete-the-look", CompleteTheLook)

class CompleteTheLookList extends HTMLElement {
  constructor() {
    super()
  }
}

customElements.define("complete-the-look-list", CompleteTheLookList)

// Abstract observer with a generic update method for flexibility
class Observer {
  update(mutationsList) {}
}

// Concrete observer for specific mutation handling
class MutationObserverHandler extends Observer {
  constructor(setTarget) {
    super()
    this.setTarget = setTarget
  }

  update(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.target.innerText !== this.setTarget.innerText) {
        this.setTarget.innerText = mutation.target.innerText
        this.setTarget.closest("a").href = window.location.pathname
      }
    }
  }
}

// Error handling and validation
class Validator {
  static validateTargets(watchTarget, setTarget) {
    if (!watchTarget || !setTarget) {
      throw new Error(
        "BreadCrumbs custom element requires valid watch-target and a child with data-breadcrumb-product-title"
      )
    }
  }
}

/**
 * Represents a custom element for displaying breadcrumbs.
 * @class BreadCrumbs
 * @extends HTMLElement
 */
class BreadCrumbs extends HTMLElement {
  constructor() {
    super()
    this.observer = new MutationObserver((mutations, obs) =>
      this.mutationHandler.update(mutations, obs)
    )
  }

  connectedCallback() {
    document.addEventListener("DOMContentLoaded", () => {
      this.init()
      this.checkLocalStorageForSampleSale()
    })
  }

  // Method to check if the current page matches the sample sale origin from local storage
  checkLocalStorageForSampleSale() {
    const sampleSaleOrigin = localStorage.getItem("sample-sale-origin")
    if (sampleSaleOrigin === window.location.pathname) {
      this.classList.remove("hidden")
      this.parentElement.classList.remove("hidden")
      this.querySelector("[data-sample-sale-item]").classList.remove("hidden")
    } else {
      localStorage.removeItem("sample-sale-origin")
    }
  }

  // Retrieve the sample sale origin from local storage, with error handling
  getSampleSaleOrigin() {
    try {
      return localStorage.getItem("sample-sale-origin")
    } catch (error) {
      console.error("Error accessing localStorage: ", error)
      return null // Return null if error to prevent further execution
    }
  }

  // Check if the current page path matches the retrieved origin
  isCurrentPage(sampleSaleOrigin) {
    return sampleSaleOrigin === window.location.pathname
  }

  // Update visibility and attributes for SEO and user display
  updateVisibilityAndAttributes() {
    this.showElement(this)
    this.showElement(this.parentElement)
    this.showElement(this.querySelector("[data-sample-sale-item]"))

    const list = this.querySelector("ol")
    this.setBreadcrumbAttributes(list)
    this.updateListItems(list.querySelectorAll("li"))
  }

  // Utility to remove 'hidden' class from an element
  showElement(element) {
    if (element) element.classList.remove("hidden")
  }

  // Set breadcrumb schema attributes on an ordered list
  setBreadcrumbAttributes(list) {
    if (!list) return
    list.setAttribute("itemscope", "")
    list.setAttribute("itemtype", "https://schema.org/BreadcrumbList")
  }

  // Set attributes and update content for list items
  updateListItems(listItems) {
    listItems.forEach((li, index) => {
      this.setItemAttributes(li, index)
      this.updateSampleSaleLinks(li)
    })
  }

  // Apply microdata attributes to list items for structured data
  setItemAttributes(li, index) {
    li.setAttribute("itemprop", "itemListElement")
    li.setAttribute("itemscope", "")
    li.setAttribute("itemtype", "https://schema.org/ListItem")
    this.setLinkAndMetaAttributes(li, index)
  }

  // Set link and metadata attributes for individual list items
  setLinkAndMetaAttributes(li, index) {
    const a = li.querySelector("a")
    const span = li.querySelector("span")
    const meta = li.querySelector("meta")

    if (a) a.setAttribute("itemprop", "item")
    if (span) span.setAttribute("itemprop", "name")
    if (meta) {
      meta.setAttribute("itemprop", "position")
      meta.setAttribute("content", index + 1)
    }
  }

  // Update links and titles based on custom data attributes
  updateSampleSaleLinks(li) {
    const a = li.querySelector("a")
    const span = li.querySelector("span")
    if (li.dataset.sampleSaleUrl) {
      a.href = li.dataset.sampleSaleUrl
      span.innerText = li.dataset.sampleSaleTitle
    }
  }

  // Remove the origin item from local storage
  clearSampleSaleOrigin() {
    try {
      localStorage.removeItem("sample-sale-origin")
    } catch (error) {
      console.error("Error removing item from localStorage: ", error)
    }
  }

  init() {
    const watchTarget = document.querySelector("[data-product-title]")
    const setTarget = this.querySelector("[data-breadcrumb-product-title]")

    if (!watchTarget || !setTarget) {
      return
    }

    // Use Validator for error handling
    Validator.validateTargets(watchTarget, setTarget)

    this.mutationHandler = new MutationObserverHandler(setTarget)

    const config = { attributes: false, childList: true, subtree: false }
    this.observer.observe(watchTarget, config)
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}

customElements.define("bread-crumbs", BreadCrumbs)

class SampleSaleHandler {
  constructor(selector) {
    this.selector = selector
    this.init()
  }

  init() {
    try {
      /* Check if page url contains products and if it doesn't, then check local storage for sample sale origin and remove if found */
      if (
        !window.location.href.includes("/products/") &&
        !window.location.href.includes("/collections/")
      ) {
        localStorage.removeItem("sample-sale-origin")
      }
      document.addEventListener("click", (event) => this.delegateEvent(event))
    } catch (error) {
      console.error("Failed to initialize event listeners", error)
    }
  }

  delegateEvent(event) {
    const targetElement = event.target.closest(this.selector)
    if (!targetElement) return

    event.preventDefault()
    this.handleElementClick(targetElement)
  }

  handleElementClick(element) {
    try {
      const href = element.getAttribute("href")
      localStorage.setItem("sample-sale-origin", href)
      if (href) {
        window.location.href = href
      } else {
        throw new Error("Missing href attribute")
      }
    } catch (error) {
      console.error("Error handling click event", error)
    }
  }
}

// Initialize the handler with the specific selector for data attribute
document.addEventListener("DOMContentLoaded", () => new SampleSaleHandler("[data-sample-sale]"))

/* Product Accordion
  - This is a custom element that can be used for product pages to create an accordion for product details.
*/
class ProductAccordion extends HTMLElement {
  constructor() {
    super()
  }
}

customElements.define("product-accordion", ProductAccordion)

// ----------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  const miniCart = document.querySelector(".mini-cart")
  const miniCartCloseButton = document.getElementById("mini-cart-close")
  const hdrBagDesktopButton = document.querySelector(".hdr--desktop .hdr__bag--desktop")
  const body = document.body

  // Flag to prevent focus on initial load
  let isInitialLoad = true

  // Function to manage focus when the mini-cart opens
  function handleMiniCartOpen() {
    if (body.classList.contains("mini-cart-open")) {
      setTimeout(() => {
        miniCartCloseButton.focus()
        isInitialLoad = false
      }, 100)
    }
  }

  // Function to manage focus when the mini-cart closes
  function handleMiniCartClose() {
    if (body.classList.contains("mini-cart-open") && !isInitialLoad) {
      hdrBagDesktopButton.focus()
    }
  }

  // Add event listeners for opening and closing of the mini-cart
  document.addEventListener("click", function (event) {
    if (event.target.closest(".hdr--desktop .hdr__bag--desktop")) {
      handleMiniCartOpen()
    }
    if (event.target.closest("#mini-cart-close")) {
      handleMiniCartClose()
    }
  })

  // Trap focus inside the mini-cart when it is open
  document.addEventListener("keydown", function (e) {
    if (body.classList.contains("mini-cart-open")) {
      const focusableElements = miniCart.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
      const firstFocusableElement = focusableElements[0]
      const lastFocusableElement = focusableElements[focusableElements.length - 1]

      if (e.key === "Tab") {
        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault()
            lastFocusableElement.focus()
          }
        } else {
          // Tab
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault()
            firstFocusableElement.focus()
          }
        }
      }
    }
  })

  miniCartCloseButton.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      setTimeout(() => {
        hdrBagDesktopButton.focus()
      }, 100)
    }
  })
})
